const techStackData = [
    { name: 'Python', img: require('../../assets/images/services/itstaff/python.png') },
    { name: 'Java', img: require('../../assets/images/services/itstaff/java.png') },
    { name: 'JavaScript', img: require('../../assets/images/services/itstaff/javascript.png') },
    { name: 'C#', img: require('../../assets/images/services/itstaff/csharp.png') },
    { name: 'C++', img: require('../../assets/images/services/itstaff/c++.png') },
    { name: 'TypeScript', img: require('../../assets/images/services/itstaff/typescript.png') },
    { name: 'SQL', img: require('../../assets/images/services/itstaff/sql.png') },
    { name: 'C', img: require('../../assets/images/services/itstaff/c.png') },
    { name: 'Go', img: require('../../assets/images/services/itstaff/golang.png') },
    { name: 'PHP', img: require('../../assets/images/services/itstaff/php.png') },
    { name: 'Swift', img: require('../../assets/images/services/itstaff/swift.png') },
    { name: 'R', img: require('../../assets/images/services/itstaff/r.png') },
    { name: 'Kotlin', img: require('../../assets/images/services/itstaff/kotlin.png') },
    { name: 'Dart', img: require('../../assets/images/services/itstaff/dart.png') },
    { name: 'Vala', img: require('../../assets/images/services/itstaff/vala.png') },
    { name: 'Julia', img: require('../../assets/images/services/itstaff/julia.png') },

];

export default techStackData;
